import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import MultiColumnSubtitleTable from './MultiColumnSubtitleTable';

const SubtitlesContainer = styled.div`
    height: 100%;
    overflow: auto;
    background-color: #1e1e1e;
`;

export default function MultiColumnSubtitles({
    columns,
    currentTime,
    currentIndex,
    player,
    handleSetTime
}) {
    const containerRef = useRef(null);
    
    // Add auto-scrolling to keep current subtitle visible
    useEffect(() => {
        if (containerRef.current && currentIndex >= 0) {
            // Find the active row element
            const activeElement = containerRef.current.querySelector(`.current-cell`);
            
            if (activeElement) {
                const container = containerRef.current;
                const containerRect = container.getBoundingClientRect();
                const elementRect = activeElement.getBoundingClientRect();
                
                // Check if element is outside visible area
                const isVisible = 
                    elementRect.top >= containerRect.top && 
                    elementRect.bottom <= containerRect.bottom;
                
                if (!isVisible) {
                    // Scroll the element into view with a small offset for context
                    activeElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            }
        }
    }, [currentIndex, currentTime, columns]);
    
    return (
        <SubtitlesContainer ref={containerRef}>
            <MultiColumnSubtitleTable
                columns={columns}
                currentIndex={currentIndex}
                currentTime={currentTime}
                player={player}
                handleSetTime={handleSetTime}
            />
        </SubtitlesContainer>
    );
}